
(function () {
  var SUPPORTED = ['DE', 'AT', 'CH'];

  var REGION = window.KS_REGION || 'DE';
  if (SUPPORTED.indexOf(REGION) === -1) REGION = 'DE';

  
  function ssGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function ssSet(key, val) {
    try { sessionStorage.setItem(key, val); } catch (e) { /* noop */ }
  }

 
  function syncCartRegion() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fixes = [];
        cart.items.forEach(function (item, idx) {
          var opts = item.options_with_values || [];
          var regionOpt = opts[2] ? opts[2].value : null;
          if (!regionOpt || regionOpt === REGION) return;
          if (SUPPORTED.indexOf(regionOpt) === -1) return; 

          fixes.push(
            fetch('/products/' + item.handle + '.js')
              .then(function (r) { return r.json(); })
              .then(function (product) {
                var target = product.variants.find(function (v) {
                  return v.option1 === opts[0].value &&
                         v.option2 === opts[1].value &&
                         v.option3 === REGION;
                });
                if (!target) return null;
                return {
                  line: idx + 1,
                  id: target.id,
                  quantity: item.quantity,
                  properties: item.properties || {}
                };
              })
              .catch(function () { return null; })
          );
        });
        return Promise.all(fixes);
      })
      .then(function (fixes) {
        
        var valid = (fixes || []).filter(Boolean).sort(function (a, b) {
          return b.line - a.line;
        });
        var chain = Promise.resolve();
        valid.forEach(function (fix) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(fix)
            });
          });
        });
        return chain;
      })
      .catch(function (e) { console.warn('Region cart sync skipped', e); });
  }

  
  if (ssGet('ks_geo_done')) { syncCartRegion(); return; }
  if (/[?&]country=/.test(location.search)) {
    ssSet('ks_geo_done', '1');
    syncCartRegion();
    return;
  }
  if (/bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) {
    syncCartRegion();
    return;
  }

  fetch('/browsing_context_suggestions.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      ssSet('ks_geo_done', '1');

      var detected =
        data && data.detected_values && data.detected_values.country &&
        data.detected_values.country.handle;

      if (detected && detected !== REGION && SUPPORTED.indexOf(detected) !== -1) {
        var url = new URL(location.href);
        url.searchParams.set('country', detected);
        location.replace(url.toString());
        return; 
      }

      syncCartRegion();
    })
    .catch(function () {
      
      syncCartRegion();
    });
})();